import { UserIcon } from '@heroicons/react/20/solid';

export default function UserProfilePicture({ 
    firstName = '', 
    lastName = '', 
    size = 'normal',
    shadow = true
}) {
    return (
        <div 
            className={`
                bg-orange-400 rounded-full flex items-center 
                h-10 w-10 2xl:h-12 2xl:w-12
                ${shadow ? 'shadow-md' : ''}
            `}
        >
                {(firstName.length > 0 && lastName.length > 0) && (
                    <div className='w-full text-sm 2xl:text-base text-center text-white font-semibold tracking-[-1px] pr-[1px] select-none'>
                        {firstName.charAt(0).toUpperCase()} {lastName.charAt(0).toUpperCase()}
                    </div>
                )}

                {(firstName.length === 0 || lastName.length === 0) && (
                    <div>
                        <div 
                            className={`
                                bg-orange-400 rounded-full flex items-center 
                                ${size === 'normal' ? 'h-12 w-12' : ''} 
                                ${size === 'large' ? 'h-16 w-16' : ''} 
                                ${size === 'extra-large' ? 'h-20 w-20' : ''} 
                                ${shadow ? 'shadow-md' : ''}
                            `}
                        >
                            <UserIcon className="h-8 text-white m-2" />
                        </div>
                    </div>
                )}
        </div>
    )
}